import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";

import "../components/auto-header";
import "../components/auto-nav";
import "../components/auto-footer";

@customElement("auto-settings")
export class AutoSettings extends LitElement {
  static styles = css`
    main {
      margin: 0;
      padding: 8px 16px;
    }
  `;

  render() {
    return html`
      <auto-header title="AUTO / uzstādījumi"></auto-header>
      <auto-nav></auto-nav>
      <main>
        <p>Nākotnē te būs aplikācijas uzstādījumi</p>
      </main>
      <auto-footer></auto-footer>
    `;
  }
}
